import { put } from 'redux-saga/effects';
import axios from 'src/api/Api';
import {
    GET_IMPERSONATION_USERDATA_SUCCESS,
    GET_IMPERSONATION_USERDATA_FAILURE,
} from '../actions';
import { updateCurrencyCode } from 'src/utils/util';
import { logUiErrorToBackend } from 'src/utils/logUiErrorToBackend';
import { SET_CONFIG_TABLE_RULES } from 'src/common/redux/actions/constants';
import {
    BASESITEID,
    JAPAN_SALESORG,
    US_COUNTRY_CODE,
    US_CURRENCY_CODE,
    US_LANGUAGE_CODE,
} from 'src/constants/appConstants';
import i18n from 'src/i18n';

export default function* getImpersonationUserData() {
    const principalUser = sessionStorage.getItem('impersonatedUserId');
    // let basesiteid = localStorage.getItem('baseSiteId');

    const url = '/occ/v2/mdt_b2bsite_us/user';

    try {
        const result = yield axios({
            method: 'get',
            url: url,
            headers: {
                PrincipalUser: principalUser,
            },
        }).then((response) => response.data);
        sessionStorage.setItem('ProxyUserRole', result.employeeRole);
        localStorage.setItem('baseSiteId', result.baseSiteId || BASESITEID);
        localStorage.setItem(
            'currencyISOCode',
            result.currencyISOCode || US_CURRENCY_CODE
        );
        localStorage.setItem(
            'languageISOCode',
            result.languageISOCode || US_LANGUAGE_CODE
        );
        localStorage.setItem(
            'countryISOCode',
            result.countryISOCode || US_COUNTRY_CODE
        );
        updateCurrencyCode(result.currencyISOCode || US_CURRENCY_CODE);
        result?.englishPreferred != 'Y' &&
        result?.languageISOCode === 'ja' &&
        result?.salesOrgs &&
        result?.salesOrgs[0] === JAPAN_SALESORG
            ? i18n.changeLanguage('ja')
            : i18n.changeLanguage('en');
        yield put({ type: GET_IMPERSONATION_USERDATA_SUCCESS, data: result });
        yield put({
            type: SET_CONFIG_TABLE_RULES,
            payload: result.configRulesDataList,
            countryISOCode: result.countryISOCode,
            salesOrgs: result.salesOrgs,
            isLanguageChanged:
                result?.englishPreferred != 'Y' &&
                result?.languageISOCode === 'ja' &&
                result?.salesOrgs &&
                result?.salesOrgs[0] === JAPAN_SALESORG,
        });
    } catch (e) {
        logUiErrorToBackend(e, {
            apiEndPoint: url,
            requestPayload: { principalUser }
        });
        yield put({
            type: GET_IMPERSONATION_USERDATA_FAILURE,
            templateError: true,
        });
    }
}
